import { User } from '../models'

export const calculateShouldFetchSingleCommunity = (communityIdOrName?: string, currentUser?: User): boolean => {
  const isCommunityIdInUrl = !!communityIdOrName
  const isGuest = !currentUser
  return isCommunityIdInUrl || isGuest
}
